import React, { Component } from "react";
import { withRouter } from "react-router";
import classNames from "classnames";
import PropTypes from "prop-types";

import Button from "components/library/Button";
import Icon from "components/library/Icon";

import styles from "./UserImage.css";

class UserImage extends Component {
  constructor(props) {
    super(props);

    this.activateImageEditor = this._activateImageEditor.bind(this);
  }

  _activateImageEditor() {
    this.props.history.push(`/settings/user/${this.props.username}/image`);
  }

  render() {
    const hasImage = this.props.image && this.props.image.crops;

    let button = null;
    if (!hasImage) {
      button = (
        <>
          <div className={styles.label}>Photo</div>
          <Button
            className={styles.button}
            role="link"
            onClick={this.activateImageEditor}
            type="secondary"
            isDisabled={this.props.disabled}
          >
            Add a photo
          </Button>
        </>
      );
    }

    return (
      <div
        className={classNames(
          styles.root,
          hasImage ? styles.hasImage : styles.noImage
        )}
      >
        {button}
        {hasImage ? (
          <figure className={styles.figure}>
            <figcaption className={styles.label}>Photo</figcaption>
            <div className={styles.placeholder}>
              <div className={styles.imageWrapper}>
                <img
                  className={styles.img}
                  src={this.props.image.crops["1x1"].url}
                />
              </div>
              {this.props.disabled ? null : (
                <div
                  className={styles.delete}
                  onClick={this.props.removeUserImage}
                >
                  <Icon name="close" className={styles.icon} />
                </div>
              )}
            </div>
          </figure>
        ) : null}
      </div>
    );
  }
}

export default withRouter(UserImage);

UserImage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  username: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  image: PropTypes.object,
  removeUserImage: PropTypes.func,
};
